// organization.store.ts
import { createEntityStore } from "@/core/factory/store"
import { createSelector } from "@reduxjs/toolkit"
import { noContext } from "@/core/utils/noContext"
import { createEmptyOrganization, Organization, ORGANIZATION_ENTITY } from "./organization.types"

export const createOrganizationStore = () => {
  const base = createEntityStore<Organization, null>(ORGANIZATION_ENTITY, createEmptyOrganization, noContext)
  return {
    ...base,
    selectors: {
      ...base.selectors,

      //If empty organization (initialized state) return false
      //Detect empty because there is no AccountId associated
      exists: createSelector([base.selectors.active], (active) => {
        return active.AccountId !== ""
      })
    }
  }
}

const organizationStore = createOrganizationStore()
export default organizationStore
